module.exports = __webpack_public_path__ + "resources/icon-right-arrow.29dc10594d455d24.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-gift/img/icon-right-arrow.png
// module id = 776
// module chunks = 0 1